<div class="map-container row gy-5">
  <div class="map-filters col-3">
    <div class="geocoder-wrapper">
      <div id="precast-geocoder"></div>
      <button mat-icon-button class="geocoder-arrow-button" aria-label="Submit location search" (click)="onArrowClick()">
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>

    <mat-label class="mat-subtitle-2">Radius (1-99 miles)</mat-label>
    <mat-slider min="1" max="99" discrete color="primary" [disabled]="!hasValidLatLng">
      <input matSliderThumb (input)="onSliderChange($event)"
        [value]="sliderValue"
        [disabled]="!hasValidLatLng"/>
      </mat-slider>

      <mat-form-field class="material-type-field">
        <mat-label>Material Type</mat-label>
        <mat-select multiple
          [value]="selectedMaterialTypes"
          [disabled]="!materialTypes.length"
          (selectionChange)="onMaterialTypeChange($event.value)">
          <mat-select-trigger>
            {{ selectedMaterialTypes.join(', ') }}
          </mat-select-trigger>
          @for (materialType of materialTypes; track materialType) {
            <mat-option [value]="materialType">
              {{ materialType }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div id="precast-map" class="match-parent col-9"></div>
  </div>
